import { useState, useEffect, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { formatPrice } from "@/utils/currency";
import { LoadingScreen } from "@/components/layout/LoadingScreen";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Search, FileText } from "lucide-react";

export function FacturasTab() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    authAxiosRef.current.get("/financiero/invoices").then(res => { setInvoices(res.data); setLoading(false); }).catch(() => { setInvoices([]); setLoading(false); });
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <div data-testid="facturas-tab">
      <div className="flex items-center gap-3 mb-4">
        <Button variant="outline" className="border-emerald-300 text-emerald-700 font-bold uppercase" data-testid="generate-invoice-btn">
          GERAR FACTURA
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="gap-1">
              <FileText className="w-4 h-4" /> EXPORTAR XMLS <span className="text-xs">&#9660;</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>Exportar XML</DropdownMenuItem>
            <DropdownMenuItem>Exportar PDF</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <div className="ml-auto relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input placeholder="Buscar" value={search} onChange={e => setSearch(e.target.value)} className="pl-9 w-64 bg-white border-gray-200" data-testid="search-facturas" />
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-gray-500 text-xs uppercase">
              <th className="text-left p-3 font-medium">Fecha</th>
              <th className="text-left p-3 font-medium">Modelo</th>
              <th className="text-left p-3 font-medium">Número</th>
              <th className="text-left p-3 font-medium">Nombre</th>
              <th className="text-left p-3 font-medium">Status</th>
              <th className="text-right p-3 font-medium">Total</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {invoices.filter(f => !search || (f.customer_name || "").toLowerCase().includes(search.toLowerCase())).map(f => (
              <tr key={f.id} className="hover:bg-gray-50 cursor-pointer">
                <td className="p-3"><span className="text-emerald-700">{new Date(f.created_at).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span></td>
                <td className="p-3">Factura</td>
                <td className="p-3">{f.id?.slice(-6) || "-"}</td>
                <td className="p-3">{f.customer_name || "-"}</td>
                <td className="p-3">{f.status === "paid" ? "Pagada" : "Erro autorizacao"}</td>
                <td className="p-3 text-right font-medium">{formatPrice(f.total)}</td>
              </tr>
            ))}
            {invoices.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-gray-400">
                <p>Mostrando un total de {invoices.length} factura</p>
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
